<template>
  <v-menu
    content-class="asc-menu-btn"
    max-width="178"
    min-width="120"
    left
    bottom
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-btn v-if="iconOnly" icon>
        <v-icon
          v-bind="attrs"
          :disabled="disabled"
          v-on="on"
          v-text="iconOnly"
        ></v-icon>
      </v-btn>
      <template v-else>
        <asc-accent-button
          :button-text="buttonText"
          :bind="attrs"
          :on="on"
          :icon="icon"
          icon-position="right"
          :disabled="disabled"
          :secondary="secondary"
        ></asc-accent-button>
      </template>
    </template>
    <v-list class="asc-list-ellipses">
      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        :disabled="item.disabled"
        :class="
          item.disabled
            ? `v-list-item-dis v-list-item-dis--${item.styleClass}`
            : `v-list-item--${item.styleClass}`
        "
        @click="handleMenuSelection(item)"
      >
        <asc-tooltip
          :tooltip="item.disabled ? item.toolTipText : ''"
          :tooltip-length="30"
          left
          max-width="300"
          :nudge-bottom="18"
        >
          <template v-bind="attrs" v-on="on">
            <v-list-item-icon v-if="item.listIcon">
              <v-icon v-text="item.listIcon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </asc-tooltip>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import AscAccentButton from './AscAccentButton.vue'
import AscTooltip from './AscTooltip.vue'
export default {
  name: 'AscMenuBtn',
  components: {
    AscAccentButton,
    AscTooltip,
  },
  props: {
    iconOnly: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleMenuSelection(buttonText) {
      if (!buttonText.disabled) this.$emit('onMenuSelect', buttonText.title)
    },
  },
}
</script>

<style lang="scss">
.asc-menu-tooltip-detached {
  $transparent-border: 8px solid transparent;
  $color-border: 8px solid $gray-1000;
  &.v-tooltip__content {
    // width: 250px;
    &.menuable__content__active {
      font-size: $font-size-sm !important;
      line-height: 18px !important;
      margin-top: 0 !important;
      padding: 5px 8px;

      &::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        clear: both;
      }

      &.asc-tooltip--arrow-right {
        margin-right: 4px;

        &::before {
          right: -8px;
          top: 7px;
          border-top: $transparent-border;
          border-bottom: $transparent-border;
          border-left: $color-border;
        }
      }
    }
  }
}
.asc-menu-btn {
  .asc-list-ellipses {
    padding-right: 10;

    .v-list-item {
      min-height: 34px;
      padding: 0;
      cursor: pointer;
      .asc-tooltip {
        display: flex;
      }
      .v-list-item__icon {
        margin: 5px;
        padding: 3 2;
        .v-icon {
          font-size: 17px;
        }
      }
      .v-list-item__content {
        padding: 0 0 4 0;
        .v-list-item__title {
          white-space: normal;
          color: $primary-black;
          font-size: 13px;
          letter-spacing: 0;
          line-height: 14px;
          padding: 0px 0 0 0px;
        }
      }
      &.v-list-item-dis {
        cursor: pointer;
        pointer-events: all;
        .asc-tooltip {
          .asc-tooltip--container {
            display: flex;
          }
        }
        .v-list-item__icon .v-icon {
          color: #bebebe;
        }
        .v-list-item__content {
          .v-list-item__icon .v-icon,
          .v-list-item__title {
            color: #bebebe !important;
          }
        }
      }
      &.v-list-item-dis--delete {
        .v-list-item__icon .v-icon,
        .v-list-item__title {
          color: #f3dbe0;
        }
      }
      &.v-list-item--delete {
        .v-list-item__icon .v-icon,
        .v-list-item__title {
          color: #9b0022;
        }
      }
      &:hover {
        background-color: $gray-100;
      }
    }
  }
}
</style>
